function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M46.812 52.543c-5.05-2.361-10.584-3.6-16.694-3.6a42.02 42.02 0 00-17.249 3.714c5.05 2.36 10.778 3.687 16.89 3.687 6.117.009 11.844-1.44 17.055-3.795z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 0.9247071,
  strokeLinejoin: "bevel"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M46.437 41.946l-.003-.005c-4.54-1.872-9.821-3.01-16.678-3.01-6.866 0-12.174 1.14-16.847 3.015 0 0 .51 4.332.531 5.764.025 1.613-.426 4.92-.426 4.92a41.338 41.338 0 0117.106-3.69c5.993 0 12.083 1.23 16.694 3.6-.757-1.514-.375-10.587-.375-10.587z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 0.9247071,
  strokeLinejoin: "bevel"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.033 52.601c4.909-2.335 10.977-3.661 17.087-3.661 5.993 0 11.024.845 16.694 3.6-.228-.636-.381-2.615-.43-3.333a46.841 46.841 0 00-16.252-2.922c-5.76 0-11.555 1.116-16.754 3.018-.109.741-.342 3.288-.342 3.288z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 0.9247071,
  strokeLinejoin: "bevel"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M57.7 14.331a2.545 2.545 0 00-3.036 4.045c-3.468 4.203-9.797 11.873-11.325 13.733-.449-.2-.914-.39-1.397-.568.137-1.427 1.14-12.313 1.671-18.103a2.546 2.546 0 002.523-1.905 2.546 2.546 0 00-4.93-1.277 2.545 2.545 0 001.281 2.89c-2.507 5.691-7.373 16.737-7.386 16.783-.002.011 0 .022-.003.034a38.25 38.25 0 00-1.36-.138c-.092-.612-2.178-13.417-3.266-20.086a2.829 2.829 0 10-3.476-2.751c0 1.34.933 2.458 2.183 2.75-1.083 6.64-3.157 19.358-3.266 20.077-.483.039-.956.085-1.418.14-.003-.017-.003-.031-.007-.046-.012-.046-4.879-11.093-7.385-16.784a2.546 2.546 0 10-1.127.291c.531 5.784 1.53 16.647 1.671 18.097-.475.173-.932.358-1.372.552-1.59-1.933-7.847-9.517-11.29-13.688a2.544 2.544 0 00-3.034-4.045 2.548 2.548 0 00-.916 3.483 2.548 2.548 0 002.946 1.148c2.07 5.392 8.754 22.747 9.01 22.987 4.606-1.875 9.903-3.016 16.767-3.016 6.86 0 12.157 1.14 16.764 3.014.254-.24 7.025-17.452 9.149-22.985a2.546 2.546 0 002.945-1.148 2.576 2.576 0 00-.94-3.482z",
  fill: "#fff",
  stroke: "#20201e",
  strokeWidth: 0.9247071
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M29.847 41.588l-2.364 1.182 2.364 1.182 2.373-1.182zM19.958 42.754l-2.147 1.548 2.522.783 2.147-1.549zM39.744 42.762l2.148 1.548-2.522.791-2.148-1.548z"
});

function SvgWhiteQueen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgWhiteQueen;